import { ConfigurationService, ConfiguratorService, OpenAPI } from '@/api-sdk';

/**
 * Get the API host URL based on the current window location.
 * @param host - The host name, defaults to the current window location host.
 * @returns The API host URL.
 */
export const getApiHost = (host: string = window.location.host) => {
  const currentHost = host.replace(/^www./, '');
  return `https://components.${currentHost}`;
};

/**
 * Set the base URL for the OpenAPI configuration.
 * @param baseUrl - The base URL to set.
 */
export const setBaseUrl = (baseUrl: string) => {
  OpenAPI.BASE = baseUrl || import.meta.env.VITE_API_BASE_URL || getApiHost();
  OpenAPI.WITH_CREDENTIALS = true;
};

/**
 * Get the current base URL from the OpenAPI configuration.
 * @returns The current base URL.
 */
export const getBaseUrl = () => {
  return OpenAPI.BASE;
};

export { ConfigurationService, ConfiguratorService };
